<template>
  <tr>
    <td v-bind:data-th="$t('site.date')">
      {{ startDate }}
    </td>
    <td v-bind:data-th="$t('site.auditresult')">
      <div v-if="state === 1 || state === 0">
        <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon>
        <span v-if="localAuditProgress !== null">{{localAuditProgress}} %</span>
      </div>
      <div v-else-if="state === 3">
        <font-awesome-icon class="text--danger" :icon="['fal','exclamation-triangle']"></font-awesome-icon>
      </div>
      <div v-else>
        <span class="pill pill--warning" v-if="auditstate === 2">
          {{ $t("audits.auditwarning") }}
        </span>
          <span class="pill pill--success" v-if="auditstate === 1">
          {{ $t("audits.auditsuccess") }}
        </span>
          <span class="pill pill--danger" v-if="auditstate === 0">
          {{ $t("audits.auditdanger") }}
        </span>
      </div>
    </td>
    <td class="text-right">
      <button class="btn btn--link" v-if="state === 2" v-on:click="showAuditDetails">{{$t('audits.viewdetails')}}</button>
    </td>
  </tr>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import mixins from '../../mixins'

export default {
  name: 'SiteDetailAuditItem',

  mixins: [mixins],

  props: [
    'id',
    'state',
    'duration',
    'created_at',
    'auditstate'
  ],

  computed: {
    ...mapState('user', [
      'userTimezone'
    ]),

    ...mapGetters('progress', [
      'auditProgress'
    ]),

    localAuditProgress () {
      return this.auditProgress(this.id)
    },

    startDate () {
      return this.transformTime(this.created_at, this.userTimezone)
    }
  },

  methods: {
    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    ...mapMutations('audit', [
      'showAuditDetail'
    ]),

    ...mapActions('audit', [
      'getAudit'
    ]),

    showAuditDetails () {
      this.showAuditDetail()

      if (!this.isLoading) {
        this.startLoading()
      }

      this.getAudit(this.id).then(
        response => {
          this.endLoading()
        }
      )
    }
  }
}
</script>
